import {DimensionValue, MetricValue} from 'common/src/modules/analytics/analytics.types';
import getAnalyticsUIName from 'common/src/modules/analytics/utils/getAnalyticsUIName';
import {DashboardWidgetType} from 'common/src/modules/dashboards/dashboards.types';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import pluralize from 'pluralize';

const COMPLEX_DIMENSION_INDICATOR = ' (';

function pluralizeDimensionUIName(dimension: DimensionValue) {
  // When creating a widget and not giving it a name - the default name is "<metric name> as
  // <dimension name>s" so if there are parentheses in the dimension name it puts the 's' after the closing parenthesis
  // Dimension UI Name -> 'Campaign (id, name)';
  // Expected result -> 'Campaigns (id, name)';
  // app.asana.com/0/1201469450635042/1206998807308674/f

  const dimensionName = getAnalyticsUIName(dimension);

  if (dimensionName.includes(COMPLEX_DIMENSION_INDICATOR)) {
    const [name, description] = dimensionName.split(COMPLEX_DIMENSION_INDICATOR);

    return `${pluralize(name, 2)}${COMPLEX_DIMENSION_INDICATOR}${description}`;
  }

  return pluralize(dimensionName, 2);
}

export default function widgetNameByMetricsAndDimensions(
  metrics: MetricValue[],
  dimensions: DimensionValue[],
  type: DashboardWidgetType,
) {
  if (_includes([DashboardWidgetType.TABLE, DashboardWidgetType.MULTI_TABLE], type)) {
    return dimensions.length < 2
      ? `${getAnalyticsUIName(dimensions[0]) || 'Dimension'} Table`
      : 'Multiple Dimensions Table';
  }

  const metricsName = _map(metrics, (metric) => pluralize(getAnalyticsUIName(metric), 2)).join(
    ' & ',
  );
  const dimensionsName = _map(dimensions, pluralizeDimensionUIName).join(' & ');

  return `${metricsName} by ${dimensionsName || 'time'}`;
}
